import { useQuery } from '@tanstack/react-query';

import { DynamicPricingExclusionConfig } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereDynamicPricingExclusionsQueryKeys } from './lereDynamicPricingExclusionsQueryKeys';

interface UseGetDynamicPricingExclusionsOptions {
  enabled?: boolean;
}

export function useGetDynamicPricingExclusions(options: UseGetDynamicPricingExclusionsOptions = {}) {
  const { enabled = true } = options;

  return useQuery<Array<DynamicPricingExclusionConfig>>({
    queryKey: lereDynamicPricingExclusionsQueryKeys.list(),
    queryFn: async ({ signal }) => {
      return await LereService.getDynamicPricingExclusions({ signal });
    },
    placeholderData: (previousData) => previousData,
    enabled,
    retry: false,
  });
}
